const InProgressIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" fill="#EFF6FF" />
      <path
        d="M21 19.9985V11H19.0195V13.7524H16.481V16.5024H13.731V19.0127H11V21H21.9995L21.2993 22H10V18.0127H12.731V15.5024H15.481V12.7524H18.0195V10H22V19.9985H21ZM11.0127 10.0029V11.0029H12.8391L10.0186 13.8892L10.7334 14.5884L13.5269 11.7299V13.4668H14.5269V10.0029H11.0127Z"
        fill="#111113"
      />
    </svg>
  )
}

export default InProgressIcon
